import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=398d903e&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"
import style0 from "./Cart.vue?vue&type=style&index=0&id=398d903e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d903e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398d903e')) {
      api.createRecord('398d903e', component.options)
    } else {
      api.reload('398d903e', component.options)
    }
    module.hot.accept("./Cart.vue?vue&type=template&id=398d903e&scoped=true", function () {
      api.rerender('398d903e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/Cart.vue"
export default component.exports